export const getSurveys = state => state.surveys.list;
export const getSelectedSurvey = state => state.surveys.selected;
export const getTimePeriods = state => state.surveys.timePeriods;
export const getTrackingTypes = state => state.surveys.trackingTypes;
export const getUserProxyIds = state => state.surveys.userProxyIds;
